import React, { useEffect, useState, useRef } from 'react';
// social/icon images
import vertexSuit_Logo from './images/vertexSuiteLogo.png';
// import metaImg from "../IntegrationSection/images/meta.png";
import whatsAppImg from "../IntegrationSection/images/whatsapp.png";
import facebookImg from "../IntegrationSection/images/facebook.png";
import instagramImg from "../IntegrationSection/images/instagram.png";
import googleImg from "../IntegrationSection/images/google.png";
import figmaImg from "../IntegrationSection/images/figma.png";

// coding images
import codeImg1 from './images/coding Img1.png';
import codeImg2 from './images/coding Img2.png';
import codeImg3 from './images/coding Img3.png';
import codeImg6 from './images/coding Img6.png';

// cards image
import integrationImg from './images/Integration Img.png';
import apiImg from './images/Api Img.png';
import webImg from './images/web Img.png';

const IntegrationSection = () => {
  const [animationStage, setAnimationStage] = useState(0);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setAnimationStage(1);
          setTimeout(() => setAnimationStage(2), 1000);
          setTimeout(() => setAnimationStage(3), 2000);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.5 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="py-5 position-relative integrations-bg"
      style={{ overflow: "hidden", marginTop: "50px" }}
      aria-label="Integration Section"
    >
      <div className="px-5 x-xxl-5 px-6 mx-auto position-relative" style={{ maxWidth: "74%", zIndex: 1 }}>
        {/* Heading */}
        <div className={`heading-content ${animationStage >= 1 ? 'fade-in' : ''}`} style={{ textAlign: "center" }}>
          <h2 style={{ fontSize: "2.5rem", fontFamily: "Inter", fontWeight: 700, color: "#242121ff", lineHeight: 1.2 }}>
            Engineered for developers
          </h2>
          <p style={{ marginTop: -2, color: "#413e3eff", fontSize: "1.1rem", fontFamily: "Poppins", fontWeight: 300, lineHeight: 1.2 }}>
            Leverage advanced integration capabilities and upgrade automation
            tools to create cohesive business experiences.
          </p>
        </div>

        {/* Half-glassy radar */}
        <div className={`radar ${animationStage >= 2 ? 'fade-in' : ''}`}>
          <div className="ring r0"></div>
          <div className="ring r1"></div>
          <div className="ring r2"></div>
          <div className="ring r3"></div>

          {/* HUB – keep Meta */}
          <div className={`chip hub ${animationStage >= 3 ? 'chip-animate' : ''}`}>
            <img src={vertexSuit_Logo} alt="VeretaxSuite" loading="lazy" />
          </div>

          {/* INNER RING (code images): replace old WhatsApp/Facebook with 4 code icons */}
          <div
            className={`chip r0-slot2 ${animationStage >= 3 ? 'chip-animate' : ''}`}
            style={{ animationDelay: '0.10s' }}
          >
            <img src={codeImg1} alt="Code 1" loading="lazy" />
          </div>

          <div
            className={`chip r0-slot ${animationStage >= 3 ? 'chip-animate' : ''}`}
            style={{ animationDelay: '0.30s' }}
          >
            <img src={codeImg2} alt="Code 2" loading="lazy" />
          </div>
          {/* extra two on same ring for spacing */}
          <div className={`chip r1-top ${animationStage >= 3 ? 'chip-animate' : ''}`} style={{ animationDelay: '0.45s' }}>
            <img src={codeImg3} alt="Code 3" loading="lazy" />
          </div>
          <div className={`chip r1-bottom ${animationStage >= 3 ? 'chip-animate' : ''}`} style={{ animationDelay: '0.60s' }}>
            <img src={codeImg6} alt="Code 6" loading="lazy" />
          </div>

          {/* MIDDLE RING (now WhatsApp, Facebook, Instagram) */}
          <div className={`chip ring-center ${animationStage >= 3 ? 'chip-animate' : ''}`} style={{ animationDelay: '0.75s' }}>
            <img src={whatsAppImg} alt="WhatsApp" loading="lazy" />
          </div>
          <div className={`chip r2-right ${animationStage >= 3 ? 'chip-animate' : ''}`} style={{ animationDelay: '0.90s' }}>
            <img src={facebookImg} alt="Facebook" loading="lazy" />
          </div>
          {/* third member on same middle ring */}
          <div className={`chip ring1-extra ${animationStage >= 3 ? 'chip-animate' : ''}`} style={{ animationDelay: '1.05s' }}>
            <img src={instagramImg} alt="Instagram" loading="lazy" />
          </div>

          {/* OUTER RING (now Google + Figma) */}
          <div className={`chip figma-center ${animationStage >= 3 ? 'chip-animate' : ''}`} style={{ animationDelay: '1.20s' }}>
            <img src={figmaImg} alt="Figma" loading="lazy" />
          </div>
          <div className={`chip r3-google ${animationStage >= 3 ? 'chip-animate' : ''}`} style={{ animationDelay: '1.35s' }}>
            <img src={googleImg} alt="Google" loading="lazy" />
          </div>
        </div>

        {/* Glass cards strip  */}
        <div className={`cards-wrap ${animationStage >= 3 ? 'fade-in' : ''}`}>
          <article className="gcard">
            <div className="gicon">
              <img className="gicon-img" src={integrationImg} alt="Integration" loading="lazy" />
            </div>
            <div className="gtext">
              <h3>Integration</h3>
              <p>Discover a wide range of SDKs, plugins and server integration options.
                Seamlessly integrate powerful tools for effortless workflows.</p>
            </div>
          </article>

          <article className="gcard">
            <div className="gicon">
              <img className="gicon-img" src={apiImg} alt="API Reference" loading="lazy" />
            </div>
            <div className="gtext">
              <h3>API Reference</h3>
              <p>Discover a wide range of SDKs, plugins and server integration options.
                Seamlessly integrate powerful tools for effortless workflows.</p>
            </div>
          </article>

          <article className="gcard">
            <div className="gicon">
              <img className="gicon-img" src={webImg} alt="Webhook" loading="lazy" />
            </div>
            <div className="gtext">
              <h3>Webhook</h3>
              <p>Discover a wide range of SDKs, plugins and server integration options.
                Seamlessly integrate powerful tools for effortless workflows.</p>
            </div>
          </article>
        </div>
      </div>

      {/* Styles – additions are only for new chips/keyframes; rest unchanged */}
      <style>{`
/* ===== Background  ===== */
.integrations-bg{
  position: relative;
  background:
    radial-gradient(900px 700px at -10% -10%, rgba(70,140,255,0.28) 0%, rgba(70,140,255,0.12) 40%, rgba(70,140,255,0.00) 78%),
    radial-gradient(680px 540px at -20% 110%, rgba(255,205,90,0.26) 0%, rgba(255,205,90,0.10) 45%, rgba(255,205,90,0.00) 80%),
    radial-gradient(1200px 900px at 110% 110%, rgba(70,140,255,0.24) 0%, rgba(70,140,255,0.09) 52%, rgba(70,140,255,0.00) 88%),
    linear-gradient(180deg, #ffffff 0%, #f9fbff 100%);
}
.integrations-bg::before{
  content:""; position:absolute; inset:0; pointer-events:none;
  background:
    linear-gradient(to bottom, rgba(255,255,255,0.85) 0%, rgba(255,255,255,0.00) 10%, rgba(255,255,255,0.00) 90%, rgba(255,255,255,0.85) 100%),
    radial-gradient(1200px 1000px at 50% 0%, rgba(255,255,255,0.20) 0%, rgba(255,255,255,0.00) 60%),
    radial-gradient(1200px 1000px at 50% 100%, rgba(255,255,255,0.20) 0%, rgba(255,255,255,0.00) 60%);
}

/* Radar base */
.radar{
  --size: min(96vw, 950px);
  position:relative; width:var(--size); height:var(--size);
  margin:0 auto; border-radius:999px; overflow:hidden;
  -webkit-mask-image: linear-gradient(to bottom, #000 0 50%, transparent 50% 100%);
          mask-image: linear-gradient(to bottom, #000 0 50%, transparent 50% 100%);
  opacity:0; transform: translateY(30px) scale(.9); transition: all .8s ease-out;
}
.radar.fade-in{ margin-top:4rem; opacity:1; transform: translateY(0) scale(1); }
.heading-content{ opacity:0; transform:translateY(40px); transition: all .8s ease-out; }
.heading-content.fade-in{ opacity:1; transform:translateY(0); }

.ring{ position:absolute; left:50%; top:50%; transform:translate(-50%,-50%);
  border-radius:999px;
  background: radial-gradient(circle at 50% 60%, rgba(255,255,255,.60) 0%, rgba(228,238,255,.50) 35%, rgba(215,233,254,.28) 70%, rgba(200,225,255,0) 100%);
  border:1px solid rgba(208,228,254,.38);
  backdrop-filter: blur(12px) saturate(140%); -webkit-backdrop-filter: blur(12px) saturate(140%);
  box-shadow: inset 0 1px 2px rgba(255,255,255,.45), 0 10px 24px rgba(100,160,255,.12);
  pointer-events:none;
}
.r0{ width:40%; height:40%; z-index:3; }
.r1{ width:72%; height:72%; z-index:2; }
.r2{ width:92%; height:92%; z-index:1; }
.r3{ width:112%; height:112%; z-index:0; }

.chip{
  width:58px; 
  height:58px; 
  border-radius:999px; 
  display:grid; 
  place-items:center;
  background: radial-gradient(circle at 30% 30%, rgba(255,255,255,0.96) 0%, rgba(245,250,255,0.95) 40%, rgba(232,242,255,0.9) 100%),
              linear-gradient(180deg, rgba(255,255,255,.6), rgba(220,235,255,.6));
  border:1px solid rgba(160,190,255,.35);
  box-shadow:0 10px 22px rgba(16,24,40,.12), 
  inset 0 1px 1px rgba(255,255,255,.8);
  backdrop-filter: blur(6px); 
  -webkit-backdrop-filter: blur(6px);
  position:absolute; 
  z-index:5; 
  pointer-events:auto;
  opacity:0; transform: translateY(50px) scale(.8); transition: all .6s ease-out;
}
.chip.chip-animate{ opacity:1; transform: translateY(0) scale(1); }
.chip img{ width:58%; height:58%; object-fit:contain; }

.hub{ top:50%; left:50%; transform: translate(-50%,-50%) translateY(50px) scale(.8); }
.hub.chip-animate{ transform: translate(-50%,-50%) translateY(0) scale(1); animation: metaCenterFloat 6s ease-in-out infinite 3s; }
@keyframes metaCenterFloat{ 0%,100%{transform: translate(-50%,-50%) translateY(0)} 50%{transform: translate(-50%,-50%) translateY(-80px)} }

/* ====== INNER RING  ====== */

.r0-slot{
  top:30%; left:50%;
  transform: translate(-50%,-50%) translateY(50px) scale(.8);
}
.r0-slot.chip-animate{
  transform: translate(-50%,-50%) translateY(0) scale(1);
  /* reuse r0-radius path (0.20 * --size), starting at 180° */
  animation: rotateRing0Facebook 10s linear infinite 3s;
}

.r0-slot2{
  top:40%; left:68%;
  transform: translate(-50%,-50%) translateY(50px) scale(.8);
}
.r0-slot2.chip-animate{
  transform: translate(-50%,-50%) translateY(0) scale(1);
  /* r0 radius = 0.20 * --size (same as other r0 anims) */
  animation: rotateRing0WhatsApp 10s linear infinite 3s;
}

/* r1-left */
.r1-left, .r1-right, .r1-top, .r1-bottom{
  top:50%; left:50%; transform: translate(-50%,-50%) translateY(50px) scale(.8);
}
.r1-left.chip-animate   { transform: translate(-50%,-50%) translateY(0) scale(1); animation: rotateRing0WhatsApp 10s linear infinite 3s; }  /* start ~270° */
.r1-right.chip-animate  { transform: translate(-50%,-50%) translateY(0) scale(1); animation: rotateRing0Facebook 10s linear infinite 3s; } /* start ~180° */
.r1-top.chip-animate    { transform: translate(-50%,-50%) translateY(0) scale(1); animation: rotateRing0Code0   10s linear infinite 3s; } /* start 0°   */
.r1-bottom.chip-animate { transform: translate(-50%,-50%) translateY(0) scale(1); animation: rotateRing0Code90  10s linear infinite 3s; } /* start 90°  */

/* inner ring keyframes (reuse your 0.20 radius) */
@keyframes rotateRing0Code0 {
  0%   { transform: translate(-50%,-50%) rotate(0deg)   translateX(calc(var(--size)*0.20)) rotate(0deg); }
  100% { transform: translate(-50%,-50%) rotate(360deg) translateX(calc(var(--size)*0.20)) rotate(-360deg); }
}
@keyframes rotateRing0Code90 {
  0%   { transform: translate(-50%,-50%) rotate(90deg)   translateX(calc(var(--size)*0.20)) rotate(-90deg); }
  100% { transform: translate(-50%,-50%) rotate(450deg)  translateX(calc(var(--size)*0.20)) rotate(-450deg); }
}
/* your existing ones kept: rotateRing0WhatsApp (start 270°) & rotateRing0Facebook (start 180°) */

/* ====== MIDDLE RING (radius ~0.36 of --size) ====== */
.ring-center, .r2-right, .ring1-extra{
  top:50%; left:50%; transform: translate(-50%,-50%) translateY(50px) scale(.8);
}
.ring-center.chip-animate { transform: translate(-50%,-50%) translateY(0) scale(1); animation: rotateRing1WhatsApp 12s linear infinite 3s; } /* 0°   */
.r2-right.chip-animate    { transform: translate(-50%,-50%) translateY(0) scale(1); animation: rotateRing1Facebook 12s linear infinite 3s; } /* 120° */
.ring1-extra.chip-animate { transform: translate(-50%,-50%) translateY(0) scale(1); animation: rotateRing1Instagram 12s linear infinite 3s; } /* 240° */

/* middle ring evenly spaced 3-way */
@keyframes rotateRing1WhatsApp {
  0%   { transform: translate(-50%,-50%) rotate(0deg)    translateX(calc(var(--size)*0.36)) rotate(0deg); }
  100% { transform: translate(-50%,-50%) rotate(360deg)  translateX(calc(var(--size)*0.36)) rotate(-360deg); }
}
@keyframes rotateRing1Facebook {
  0%   { transform: translate(-50%,-50%) rotate(120deg)  translateX(calc(var(--size)*0.36)) rotate(-120deg); }
  100% { transform: translate(-50%,-50%) rotate(480deg)  translateX(calc(var(--size)*0.36)) rotate(-480deg); }
}
@keyframes rotateRing1Instagram {
  0%   { transform: translate(-50%,-50%) rotate(240deg)  translateX(calc(var(--size)*0.36)) rotate(-240deg); }
  100% { transform: translate(-50%,-50%) rotate(600deg)  translateX(calc(var(--size)*0.36)) rotate(-600deg); }
}

/* ====== OUTER RING (radius ~0.46 of --size) ====== */
.figma-center, .r3-google{
  top:50%; left:50%; transform: translate(-50%,-50%) translateY(50px) scale(.8);
}
.figma-center.chip-animate { transform: translate(-50%,-50%) translateY(0) scale(1); animation: rotateRing2Figma 15s linear infinite 3s; }  /* 0° */
.r3-google.chip-animate    { transform: translate(-50%,-50%) translateY(0) scale(1); animation: rotateRing2Google 15s linear infinite 3s; } /* 180° */

@keyframes rotateRing2Figma {
  0%   { transform: translate(-50%,-50%) rotate(0deg)   translateX(calc(var(--size)*0.46)) rotate(0deg); }
  100% { transform: translate(-50%,-50%) rotate(360deg) translateX(calc(var(--size)*0.46)) rotate(-360deg); }
}
@keyframes rotateRing2Google {
  0%   { transform: translate(-50%,-50%) rotate(180deg)  translateX(calc(var(--size)*0.46)) rotate(-180deg); }
  100% { transform: translate(-50%,-50%) rotate(540deg)  translateX(calc(var(--size)*0.46)) rotate(-540deg); }
}

/* === FIX inner ring chips to orbit from the center === */
/* Center-origin like the other chips */
.r0-slot,
.r0-slot2{
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) translateY(50px) scale(.8);
}

/* Animate them on the same r0 radius with different start angles */
.r0-slot.chip-animate{
  transform: translate(-50%, -50%) translateY(0) scale(1);
  /* start at 180° */
  animation: rotateRing0Code180 10s linear infinite 3s;
}

.r0-slot2.chip-animate{
  transform: translate(-50%, -50%) translateY(0) scale(1);
  /* start at 270° */
  animation: rotateRing0Code270 10s linear infinite 3s;
}

/* === New keyframes for inner ring (radius ~ 0.20 * --size) === */
@keyframes rotateRing0Code180 {
  0%   { transform: translate(-50%, -50%) rotate(180deg) translateX(calc(var(--size) * 0.20)) rotate(-180deg); }
  100% { transform: translate(-50%, -50%) rotate(540deg)  translateX(calc(var(--size) * 0.20)) rotate(-540deg); }
}

@keyframes rotateRing0Code270 {
  0%   { transform: translate(-50%, -50%) rotate(270deg) translateX(calc(var(--size) * 0.20)) rotate(-270deg); }
  100% { transform: translate(-50%, -50%) rotate(630deg)  translateX(calc(var(--size) * 0.20)) rotate(-630deg); }
}


/* Cards & other styles  */
.cards-wrap{ margin-top:-17rem; display:grid; grid-template-columns:repeat(3,1fr); gap:24px; }
@media (max-width:1200px){ .cards-wrap{ grid-template-columns:repeat(2,1fr); } }
@media (max-width:768px){ .cards-wrap{ grid-template-columns:1fr; } }

/* === Glassmorphism like the reference === */
.gcard{
  margin-top:-5rem;
  position: relative;
  display: grid;
  grid-template-columns: 70px 1fr;
  align-items: center;
  gap: 16px;
  padding: 32px 32px;
  border-radius: 16px;
  background:
    radial-gradient(140% 120% at 10% 10%,
      rgba(255,255,255,0.70) 0%,
      rgba(255,255,255,0.28) 38%,
      rgba(255,255,255,0.12) 60%,
      rgba(255,255,255,0.06) 100%),
    linear-gradient(180deg,
      rgba(255,255,255,0.60),
      rgba(255,255,255,0.20));

  border: 1px solid rgba(255,255,255,0.65);
  backdrop-filter: blur(14px) saturate(160%);
  -webkit-backdrop-filter: blur(14px) saturate(160%);

  /* soft lift */
  box-shadow:
    0 4px 10px rgba(17,25,40,0.08),
    0 20px 44px rgba(17,25,40,0.12);

  color: #1b1f2a;
  transition: transform .2s ease, box-shadow .2s ease, border-left .2s ease;
  isolation: isolate;
}

/* top-left glaze highlight */
.gcard::before{
  content: "";
  position: absolute;
  inset: 1px;
  border-radius: inherit;
  background: linear-gradient(135deg,
    rgba(255,255,255,0.85) 0%,
    rgba(255,255,255,0.35) 22%,
    rgba(255,255,255,0.00) 55%);
  pointer-events: none;
  z-index: 0;
  mix-blend-mode: overlay;
  opacity: .7;
}

/* soft shadow under the card (like it’s floating) */
.gcard::after{
  content: "";
  position: absolute;
  left: 10%;
  right: 10%;
  bottom: -18px;
  height: 36px;
  background: radial-gradient(60% 100% at 50% 0,
    rgba(9,20,40,.16),
    rgba(9,20,40,0) 70%);
  filter: blur(6px);
  z-index: -1;
  pointer-events: none;
}

/* hover—slightly brighter + lift; keeps your blue accent */
.gcard:hover{
  transform: translateY(-2px);
  box-shadow:
    0 12px 26px rgba(17,25,40,.12),
    0 36px 72px rgba(17,25,40,.16);
  border-left: 4px solid #054E91;
}

/* icon tile also glassy to match the card */
.gicon{
  width: 74px; height: 74px; border-radius: 12px;
  display: grid; place-items: center;
  background: linear-gradient(180deg,
    rgba(255,255,255,0.55),
    rgba(255,255,255,0.18));
  border: 1px solid rgba(255,255,255,0.65);
  box-shadow:
    inset 0 1px 1px rgba(255,255,255,.85),
    0 6px 18px rgba(17,25,40,.10);
}

/* keep your existing icon color */
.gicon svg path{ stroke:#054E91; fill:#054E91; }

/* slightly darker headings/body for readability on glass */
.gtext h3{ 
    margin:0 0 6px 0; 
    font-weight:600; 
    font-size:20px; 
    font-family:Lato; 
    color: #393535ff; 
}
.gtext p{ 
   line-height:1.18; 
   font-size:17px; 
   font-family:Lato; 
   font-weight:400; 
   color: #6B6B6B;
}

/* stack content: icon ➜ title ➜ description (no JSX change needed) */
.gcard{
  display: flex;                 /* was grid */
  flex-direction: column;
  align-items: center;           /* center icon + text */
  text-align: center;
  padding: 28px 26px;            /* a bit tighter to match compact look */
}

/* smaller icon tile */
.gicon{
  width: 56px;                   /* was 74px */
  height: 56px;
  border-radius: 12px;
  display: grid; place-items: center;
  margin: 2px auto 10px;         /* add space below icon */
  background: linear-gradient(180deg, rgba(255,255,255,0.55), rgba(255,255,255,0.18));
  border: 1px solid rgba(255,255,255,0.65);
  box-shadow:
    inset 0 1px 1px rgba(255,255,255,.85),
    0 6px 18px rgba(17,25,40,.10);
}

/* keep icon color */
.gicon svg path, .gicon svg circle { stroke:#054E91; }

/* tidy typography under icon */
.gtext h3{
  margin: 4px 0 6px;
  font-weight: 600;
  font-size: 19px;
}
.gtext p{
  margin: 0;
  line-height: 1.25;
  font-size: 16px;
}


.gcard{
  display: grid !important;                 
  grid-template-columns: 92px 1fr;        
  align-items: center;
  text-align: left;
  padding: 24px 26px;                     
  gap: 18px;
}

/* Icon tile (keeps your glass look) */
.gicon{
  width: 72px;                             
  height: 72px;
  border-radius: 12px;
  display: grid; place-items: center;
  background: linear-gradient(180deg,
    rgba(255,255,255,0.55),
    rgba(255,255,255,0.18));
  border: 1px solid rgba(255,255,255,0.65);
  box-shadow:
    inset 0 1px 1px rgba(255,255,255,.85),
    0 6px 18px rgba(17,25,40,.10);
  overflow: hidden;                         
}

/* The icon image inside the tile */
.gicon-img{
  width: 100%;
  height: 100%;
  object-fit: contain;                      /* keep proportions like ref */
  /* Dark-blue tint to match #054E91 (good PNG approximation) */
  filter: brightness(0) saturate(100%)
          invert(18%) sepia(77%) saturate(1732%)
          hue-rotate(192deg) brightness(88%) contrast(96%);
  /* optional subtle inner glow for depth */
  /* box-shadow: inset 0 0 0 1px rgba(5,78,145,.05); */
}

/* Title + description sizes tuned for that clean, airy look */
.gtext h3{
  margin: 2px 0 6px;
  font-weight: 700;
  font-size: 20px;
  color: #2B2F36;
}
.gtext p{
  margin: 0;
  font-size: 15.5px;
  line-height: 1.25;
  color: #6B6B6B;
}

/* --- Make the card pure-white glass & remove inner dark haze under text --- */
.gcard{
  background:
    linear-gradient(180deg, rgba(255,255,255,0.90), rgba(255,255,255,0.70)); /* brighter white */
  box-shadow:
    0 6px 16px rgba(17,25,40,0.10),      /* softer outer shadow */
    0 18px 38px rgba(17,25,40,0.10);
}

/* Remove the glaze overlay that was causing a grey cast under text */
.gcard::before{
  background: none !important;
  opacity: 0 !important;
}

/* Keep the “floating” feel but make the drop shadow lighter */
.gcard::after{
  opacity: .10;               /* was stronger; lighten it */
  filter: blur(6px);
}

/* Ensure absolutely no text shadow anywhere (just in case) */
.gtext h3, .gtext p{
  text-shadow: none !important;
}


      `}</style>
    </section>
  );
};

export default IntegrationSection;
